import { createAPI } from '@/request.js'
// 用户列表
export const list = data => createAPI('/api/user/query.mt', 'post', data)
// 收益明细
export const statement = data => createAPI('/api/user/statement/query.mt', 'post', data)
// 明细导出
export const excel = data => createAPI('/download/user/statement/excel', 'get', data)

export const editUser = data => createAPI('/api/user/edit.mt', 'post', data)
